import { useQueryClient } from '@tanstack/react-query'
import { z } from 'zod'
import { useRestMutation } from '@/lib/hook/tanstackQuery'
import { ApiMutationEndpoint } from '@/src/ApiMutationEndpoint'
import { ApiQueryEndpoint } from '@/src/ApiQueryEndpoint'

const createSubscriptionSchema = z.object({
  redirectUrl: z.string(),
})

type CreateSubscriptionInput = z.infer<typeof createSubscriptionSchema>

interface CreateSubscriptionResponse {
  url?: string
  reason_text?: string
}

export const useCreateSubscription = () => {
  const queryClient = useQueryClient()

  return useRestMutation<CreateSubscriptionResponse, Error, CreateSubscriptionInput>({
    ...ApiMutationEndpoint.SUBSCRIPTION.CREATE_SUBSCRIPTION,
    schema: createSubscriptionSchema,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ApiQueryEndpoint.USERS.GET_PROFILE.endpoint] })
    },
  })
}

const deleteSubscriptionSchema = z.object({
  id: z.union([z.string(), z.number()]),
})

type DeleteSubscriptionInput = z.infer<typeof deleteSubscriptionSchema>

interface DeleteSubscriptionResponse {
  success?: boolean
  reason_text?: string
}

export const useDeleteSubscription = () => {
  const queryClient = useQueryClient()

  return useRestMutation<DeleteSubscriptionResponse, Error, DeleteSubscriptionInput>({
    ...ApiMutationEndpoint.SUBSCRIPTION.DELETE_SUBSCRIPTION,
    schema: deleteSubscriptionSchema,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ApiQueryEndpoint.USERS.GET_PROFILE.endpoint] })
      queryClient.invalidateQueries({
        queryKey: [ApiQueryEndpoint.SUBSCRIPTION.GET_SUBSCRIPTIONS.endpoint],
      })
    },
  })
}
